import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/deployment/overview.md?raw';

const DeploymentOverview: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default DeploymentOverview;
